import axios from "axios";
import { HEADERS } from "../../../API/UrlAndPaths";
import store from "../../../Redux/store";
import { setSubmitLoading } from "../../../Redux/Dashboard/mainDashBoardSlice";

// --- LOYALTY ---

export const getLoyaltyHistoryAPI = async (customerId) => {
  try {
    const res = await axios.get(`api/crm/loyalty/${customerId}`, HEADERS);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    console.error("Error fetching loyalty history:", e);
    return null;
  }
};

export const transactionLoyaltyAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/loyalty/transaction`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error in loyalty transaction:", e);
    return null;
  }
};

// --- FEEDBACK ---

export const getFeedbackListAPI = async (setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm/feedback`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : [];
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error fetching feedback:", e);
    return [];
  }
};

export const submitFeedbackAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/feedback`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error submitting feedback:", e);
    return null;
  }
};

// --- CAMPAIGNS ---

export const createCampaignAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/campaigns`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error creating campaign:", e);
    return null;
  }
};

export const sendCampaignAPI = async (id, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/campaigns/${id}/send`, {}, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error sending campaign:", e);
    return null;
  }
};

// --- FORMS ---

export const createFormTemplateAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-forms/templates`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error creating form template:", e);
    return null;
  }
};

export const getFormTemplatesAPI = async (setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm-forms/templates`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : [];
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error fetching form templates:", e);
    return [];
  }
};

export const submitFormResponseAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-forms/submissions`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error submitting form:", e);
    return null;
  }
};

export const updateFormTemplateAPI = async (id, body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.put(`api/crm-forms/templates/${id}`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error updating form template:", e);
    return null;
  }
};

export const deleteFormTemplateAPI = async (id, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.delete(`api/crm-forms/templates/${id}`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error deleting form template:", e);
    return false;
  }
};

export const getFormSubmissionsAPI = async (formId, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm-forms/submissions/${formId}`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : [];
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error fetching form submissions:", e);
    return [];
  }
};

export const generateFormWithAIAPI = async (prompt, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-forms/ai/generate`, { prompt }, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating form with AI:", e);
    return null;
  }
};

export const improveQuestionWithAIAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-forms/ai/improve-question`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error improving question with AI:", e);
    return null;
  }
};

// --- AI ---

export const analyzeSentimentAPI = async (text, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/analyze-sentiment`, { text }, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error analyzing sentiment:", e);
    return null;
  }
};

export const generateCampaignContentAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/generate-campaign`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating content:", e);
    return null;
  }
};

export const predictChurnAPI = async (customerId, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/predict-churn/${customerId}`, {}, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error predicting churn:", e);
    return null;
  }
};

// --- OFFERS ---

export const getOffersAPI = async (setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm/offers`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : [];
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error fetching offers:", e);
    return [];
  }
};

export const getOfferByIdAPI = async (id, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm/offers/${id}`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error fetching offer:", e);
    return null;
  }
};

export const createOfferAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/offers`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error creating offer:", e);
    return { success: false, message: e.response?.data?.data || "Failed to create offer" };
  }
};

export const updateOfferAPI = async (id, body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.put(`api/crm/offers/${id}`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error updating offer:", e);
    return { success: false, message: e.response?.data?.data || "Failed to update offer" };
  }
};

export const deleteOfferAPI = async (id, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.delete(`api/crm/offers/${id}`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error deleting offer:", e);
    return false;
  }
};

export const toggleOfferAPI = async (id, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.patch(`api/crm/offers/${id}/toggle`, {}, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error toggling offer:", e);
    return null;
  }
};

export const validateOfferCodeAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/offers/validate`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error validating offer:", e);
    return { success: false, message: e.response?.data?.data || "Invalid promo code" };
  }
};

export const redeemOfferAPI = async (id, body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/offers/${id}/redeem`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error redeeming offer:", e);
    return null;
  }
};

export const getOfferAnalyticsAPI = async (id, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm/offers/${id}/analytics`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error fetching offer analytics:", e);
    return null;
  }
};

// --- AI OFFERS ---

export const generateAIOfferSuggestionsAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/generate-offer-suggestions`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating AI offer suggestions:", e);
    return null;
  }
};

export const analyzeOfferPerformanceAIAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/analyze-offer-performance`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error analyzing offer performance:", e);
    return null;
  }
};

export const generatePersonalizedOfferAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/generate-personalized-offer`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating personalized offer:", e);
    return null;
  }
};

export const generateCampaignContentAIAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/generate-campaign-content`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating campaign content:", e);
    return null;
  }
};

export const generateCampaignVariationsAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/generate-campaign-variations`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating campaign variations:", e);
    return null;
  }
};

export const generateCampaignIdeasAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-ai/generate-campaign-ideas`, body, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error generating campaign ideas:", e);
    return null;
  }
};

// --- WHATSAPP ---

export const getWhatsAppStatusAPI = async (setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.get(`api/crm/whatsapp/status`, HEADERS);
    setLoading && setLoading(false);
    return res.status === 200 ? res.data.data : null;
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error checking WhatsApp status:", e);
    return null;
  }
};

export const sendOfferAPI = async (offerId, body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/offers/${offerId}/send`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error sending offer:", e);
    return { success: false, message: e.response?.data?.data || "Failed to send offer" };
  }
};

export const sendOfferWhatsAppAPI = async (offerId, body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/offers/${offerId}/send-whatsapp`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error sending offer via WhatsApp:", e);
    return { success: false, message: e.response?.data?.data || "Failed to send offer" };
  }
};

export const sendFormWhatsAppAPI = async (formId, body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm-forms/templates/${formId}/send-whatsapp`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error sending form via WhatsApp:", e);
    return { success: false, message: e.response?.data?.data || "Failed to send form" };
  }
};

export const sendWhatsAppBroadcastAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  try {
    const res = await axios.post(`api/crm/whatsapp/send`, body, HEADERS);
    setLoading && setLoading(false);
    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
    return { success: false, message: res.data.data };
  } catch (e) {
    setLoading && setLoading(false);
    console.error("Error sending WhatsApp broadcast:", e);
    return { success: false, message: e.response?.data?.data || "Failed to send message" };
  }
};
